export default {
    en: {
        id: 'diagram4c2-1',
        blocks: [
            {
                task: 'S = Orlando’s decentralized purchasing process spends $600 million/year on products and services. No formal supplier evaluation/qualification process.',
                title: "S = ",
                answer: 'We do X in Y way now',
                modelName: 's'
            },
            {
                task: 'C = Risk we may be paying more, getting less good service.',
                title: "C = ",
                answer: 'Have a problem',
                modelName: 'c'
            },
            {
                task: 'Q = (What do about it?)',
                title: "Q = What should we do?",
                answer: ' ',
                disableEdit: true
            }
        ],
        title: 'Type in roughly what the Situation and Complication should say',
        note: 'This is a classic structure, used whenever you write to tell someone how to do something properly (as opposed to how to do it at all).  You always begin by reminding them how they do it now.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c2/practiceInSeeing3/i18n/exercise1.js